/**
 * @generated SignedSource<<400808bb231f4a86bba4fbb0fb9c37bc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type currencyHelpers_financialAmount$data = {
  readonly convertedAmountList: ReadonlyArray<{
    readonly amount: number | null;
    readonly currency: Currency | null;
  } | null> | null;
  readonly " $fragmentType": "currencyHelpers_financialAmount";
};
export type currencyHelpers_financialAmount$key = {
  readonly " $data"?: currencyHelpers_financialAmount$data;
  readonly " $fragmentSpreads": FragmentRefs<"currencyHelpers_financialAmount">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "currencyHelpers_financialAmount"
};

(node as any).hash = "4665de573c79d39b701484c8e828f1c0";

export default node;
